import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { func, string } from 'prop-types';

ReCaptcha.propTypes = {
  sitekey: string,
  callback: func,
  theme: string
};

ReCaptcha.defaultProps = {
  sitekey: "6LeYD54aAAAAAD3g9LLqZbj6qX3jJIky50as1HoL",
  theme: 'light'
}

function ReCaptcha(props) {
  const { sitekey, callback, theme } = props;

  return (
    <div key={theme}>
      <ReCAPTCHA
        sitekey={sitekey}
        onChange={callback}
        theme={theme}
      />
    </div>
  );
}

export default ReCaptcha;
